import { Redirect } from 'expo-router';

import CheckoutPage from 'experiments/checkout-v2/treatment/features/checkout/pages';
import { useEnableCheckoutV2Experiment } from 'experiments/checkout-v2/use-enable-checkout-v2-experiment';
import { useRumPageView } from 'hooks/rum/use-rum-page-view';
import { routes } from 'utils/routing';

export default function Checkout() {
  useRumPageView('checkout', 'Checkout');
  const isCheckoutV2 = useEnableCheckoutV2Experiment();

  if (!isCheckoutV2) {
    return <Redirect href={routes.cart} />;
  }

  return <CheckoutPage />;
}
